import { browser } from '@/models/browser.js'
import { eventSystem } from '@/models/eventSystem.js'
import { evaluationSystem } from '@/models/evalSystem.js'


const error = Object.freeze({
  "none": 0,
  "default": 1,
  "notImplemented": 2,
  "payload": 3,
  "server": 4
})
let errorToThrow = error.default;

const config = {
  // Just de/activates console.log when exceptions happen
  debug: false,
  evalEventID: "evaluation",
  evalEventID_Test: "testingEval",
  localStorageID: "userEmail"
}

const interfaces = {
  kitchenDataEvent: ["form", "style", "brand", "condition", "fridge", "oven", "dishwasher", "plz", "email"],
  kitchenDataEval: ["formID", "styleID", "brandID", "conditionID", "fridgeID", "ovenID", "dishwasherID", "plz", "email"]
}

const apis = {
  event: eventSystem,
  browser: browser,
  evaluate: evaluationSystem
}

const components = {
  checkForString: (propsAsArray, obj) => {
    if (!Array.isArray(propsAsArray)) {
      throw Error("Array of props is not an array");
    }
    if (!((typeof(obj) === "object") && (obj !== null))) {
      throw Error("Object to check is not an object or null");
    } 
    propsAsArray.forEach((entry) => {
      let typeOfEntry = typeof(obj[entry]);
      if (typeOfEntry !== 'string') {
        throw Error("evalManager: " + entry + " has to be a string but is of type " + typeOfEntry);
      } 
    })
    return true;
  },
  extractPropsAsNewObject: (propsAsArray, oldObj) => {
    components.checkForString(propsAsArray, oldObj);
    const newObj = {};
    propsAsArray.forEach((entry) => {
      newObj[entry] = oldObj[entry]
    });
    return newObj;
  }
}

const calls = {
  evaluationDetails: async (commit, formAndStyle) => {
    errorToThrow = error.payload;
    components.checkForString(["form", "style", "formID", "styleID"], formAndStyle);
    if (config.debug) {
      console.log("Form:", formAndStyle.form, "Style:", formAndStyle.style,
       "FormID:", formAndStyle.formID, "StyleID:", formAndStyle.styleID);
    }
    commit("formAndStyle", formAndStyle);
  },

  evaluationSubmit: async (commit, state, details) => {
    errorToThrow = error.payload;
    const userData = Object.assign(
      details,
      {form: state.evalKitchenData.form, style: state.evalKitchenData.style},
      {formID: state.evalKitchenData.formID, styleID: state.evalKitchenData.styleID}
    );
    if (config.debug) {console.log("UserData:", userData);}
    const strippedData = components.extractPropsAsNewObject(interfaces.kitchenDataEvent, userData);
    const strippedDataEval = components.extractPropsAsNewObject(interfaces.kitchenDataEval, userData);

    errorToThrow = error.server;
    await apis.event.dispatch(config.evalEventID, strippedData);

    await apis.evaluate.dispatch(strippedDataEval, config.debug);

    commit("evaluationSubmit", details.email);
    apis.browser.saveToLocalStorage(config.localStorageID, {email: details.email}) 

    if (config.debug) {console.log("Evaluation Complete");}
  },

  setup: async (commit) => {
    const storeData = apis.browser.getFromLocalStorage(config.localStorageID);
    if (storeData == null) {
      return;
    }
    if (config.debug) {console.log("Evaluation restored:", storeData);}
    commit("evaluationSubmit", storeData.email);
  }
}

const actions = {
  async evalManagerDispatch(
    {commit, state, rootState, rootGetters}, //eslint-disable-line
    {action, payload}) { //eslint-disable-line
    errorToThrow = error.default;
    commit("loading", true);
    try {
      switch (action) {
      case 'setup':
        await calls.setup(commit);
        break;
      case 'evaluationSubmit':
        await calls.evaluationSubmit(commit, state, payload);
        break;
      case 'evaluationDetails':
        await calls.evaluationDetails(commit, payload);
        break; 
      default:
        errorToThrow = error.notImplemented;
        throw "Action '"+ action + "' is not implemented";
      }
      commit('clearError'); 
    } catch (Exception) {
      if (config.debug) {
        console.log("EvalManager: Reducer failed with ", Exception);
      }
      commit('error', errorToThrow) 
    }
    commit("loading", false);
  },
};


const state = {
  error: error.none,
  isLoading: false,
  evalComplete: null,
  evalKitchenData: {form: null, stil: null, formID: null, stilID: null, email: null}
};

const getters = {
  evalManager: (state) => {
    return {
      errorName: Object.keys(error)[state.error],
      error: state.error,
      isLoading: state.isLoading,
      evalComplete: state.evalComplete,
      userEmail: state.evalKitchenData.email
    }
  },
  // To compare Errorstates less error proune
  EvalManagerError: () => {return Object.assign(error)}, 
};

const mutations = {
  error: (state, error) => {state.error = error;},
  clearError: (state) => {state.error = error.none;},
  loading: (state, isLoading) => {state.isLoading = isLoading;},
  evaluationSubmit: (state, email) => {state.evalComplete = true; state.evalKitchenData.email = email;},
  formAndStyle: (state, formAndStyle) => {
    state.evalComplete = false;
    state.evalKitchenData.form = formAndStyle.form;
    state.evalKitchenData.style = formAndStyle.style; 
    state.evalKitchenData.formID = formAndStyle.formID;
    state.evalKitchenData.styleID = formAndStyle.styleID;  
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  calls,
  interfaces,
  apis,
  components,
  config,
}